import { render, staticRenderFns } from "./DepositChargeOverDue.vue?vue&type=template&id=cb2b228e"
import script from "./DepositChargeOverDue.vue?vue&type=script&lang=js"
export * from "./DepositChargeOverDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports